export function getCsvFilename(object: ObjectDto, stack: StackDto) {
    return `${sanitize(`${stack.name}_${object.name}`)}.csv`
}

const ALLOWED_CHARS = /[^a-z0-9]/gi

function sanitize(str: string) {
    return str.replace(ALLOWED_CHARS, '_').toLowerCase()
}
